import React, { useEffect, useState } from 'react';
import { fetchAllWorkflows } from '../../api/WorkflowApi';
import { Workflow } from '../model';
import ItemList from '../list/ItemList';
import LinkButton from '../button/LinkButton';

const Workflows: React.FC = () => {
  const [workflows, setWorkflows] = useState<Workflow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAllWorkflows()
      .then(setWorkflows)
      .catch(() => setError('Failed to load workflows'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  return (
    <>
      <div className="header-container">
        <LinkButton label="Create Workflow" link="/workflow" />
      </div>
      <ItemList
        items={workflows}
        linkPrefix="workflow"
        renderName={workflow => workflow.name || ''}
        renderStatus={workflow => workflow.status}
      />
    </>
  );
};

export default Workflows;
